/**
 * Formats the given string to lowercase, separates words
 * if they are next to each other without space and removes
 * any additional whitespaces and replaces the special
 * German letters in the text to basic latin letters
 * (e.g. `ß` to `ss`, `ä` to `ae`, and so on).
 * This step is requested by Digital Power,
 * to process the incoming data more easily.
 */
export const formatToTrackingString = (value: string, maxLength = 100): string =>
    value.replace(/([a-z])([A-Z])/g, '$1 $2')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ')
        .substring(0, maxLength)
        .replace(/\u00e4/g, 'ae')
        .replace(/\u00f6/g, 'oe')
        .replace(/\u00fc/g, 'ue')
        .replace(/\u00df/g, 'ss');
